import { X, Check } from 'lucide-react';
import { EXPLORE_SORT_OPTIONS } from '@utils/exploreSort';

const ExploreSortSheet = ({ open, selectedSort, onClose, onSelectSort }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1205]">
      <button type="button" className="absolute inset-0 bg-black/45" aria-label="Close sort" onClick={onClose} />
      <div
        className="absolute bottom-0 left-0 right-0 flex max-h-[85vh] flex-col rounded-t-3xl border border-surface-200 bg-white shadow-2xl animate-slide-up dark:border-surface-700 dark:bg-surface-900 lg:bottom-auto lg:left-1/2 lg:top-1/2 lg:max-h-[min(85vh,520px)] lg:w-[min(100vw-2rem,42rem)] lg:-translate-x-1/2 lg:-translate-y-1/2 lg:rounded-3xl lg:shadow-2xl lg:animate-none"
        role="dialog"
        aria-modal="true"
        aria-labelledby="explore-sort-sheet-title"
      >
        <div className="mx-auto mt-2 h-1 w-10 shrink-0 rounded-full bg-surface-300 dark:bg-surface-600 lg:hidden" />

        <div className="flex shrink-0 items-center justify-between border-b border-surface-100 px-4 py-3 dark:border-surface-800 lg:px-8 lg:py-4">
          <h2
            id="explore-sort-sheet-title"
            className="text-base font-extrabold text-surface-900 dark:text-white lg:text-lg"
          >
            Sort by
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl p-2 text-surface-500 hover:bg-surface-100 dark:hover:bg-surface-800 lg:p-2.5"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 py-2 lg:px-8 lg:py-6">
          <ul className="space-y-0.5 lg:grid lg:grid-cols-3 lg:gap-4 lg:space-y-0">
            {EXPLORE_SORT_OPTIONS.map((opt) => {
              const selected = selectedSort === opt.id;
              return (
                <li key={opt.id} className="lg:min-h-0">
                  <button
                    type="button"
                    onClick={() => onSelectSort(opt.id)}
                    className={`flex w-full items-center gap-3 rounded-2xl px-3 py-3.5 text-left transition-colors lg:h-full lg:min-h-[152px] lg:flex-col lg:items-stretch lg:justify-between lg:gap-3 lg:border-2 lg:px-4 lg:py-5 ${
                      selected
                        ? 'bg-brand-50 dark:bg-brand-500/10 lg:border-brand-500 lg:bg-brand-50/90 dark:lg:border-brand-400 dark:lg:bg-brand-500/15'
                        : 'hover:bg-surface-50 dark:hover:bg-surface-800/60 lg:border-surface-200 lg:bg-surface-50/50 hover:lg:border-brand-200 dark:lg:border-surface-700 dark:lg:bg-surface-800/30'
                    }`}
                  >
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-bold text-surface-900 dark:text-white lg:text-base">{opt.label}</p>
                      <p className="mt-0.5 text-xs text-surface-500 dark:text-surface-400 lg:mt-2 lg:text-sm">
                        {opt.hint}
                      </p>
                    </div>
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 lg:self-end ${
                        selected
                          ? 'border-brand-500 bg-brand-500 text-white dark:border-brand-400 dark:bg-brand-500'
                          : 'border-surface-200 bg-white dark:border-surface-600 dark:bg-surface-800'
                      }`}
                      aria-hidden
                    >
                      {selected ? <Check size={18} strokeWidth={2.5} /> : null}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ExploreSortSheet;
